/*
 * Public API Surface of pepperi-lib/textarea
 */
export * from './textarea.module';
export * from './textarea.component';
